/*
 * @Author: your name
 * @Date: 2021-05-26 16:55:50
 * @LastEditTime: 2022-06-24 11:17:06
 * @LastEditors: fengzhongmei 996180799@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \rightcloud-console\src\service\innerService.js
 */
export const typeList = {
    OBS: '对象存储 OBS',
    'ECS-X86': '云主机 ECS',
    EVS: '云硬盘 EVS',
    VPC: '虚拟私有云 VPC',
    VPN: '虚拟专用网络 VPN',
    'EIP-INNER': '弹性公网IP EIP',
    DC: '云专线 DC',
    IMS: '镜像服务 IMS',
    CBR: '云备份 CBR',
    ELB: '弹性负载均衡 ELB',
    CES: '云监控服务 CES',
    SWR: '容器镜像服务 SWR'
}

// 计费的内置服务
export const chargeInnerService = ['OBS', 'DRP', 'IAAS', 'ModelArts', 'SFS2.0', 'HPC-DRP']

// 不记录数据的组件
export const notComponet = ['line', 'content', 'table']

export const baseService = ['OBS', 'ECS-X86', 'EVS', 'VPC', 'VPN', 'EIP-INNER', 'DC', 'IMS', 'CBR', 'ELB', 'CES', 'SWR', 'DRP', 'ModelArts', 'IAAS', 'SFS2.0', 'HPC', 'HPC-SAAS', 'HPC-DRP', 'ECS', 'BMS']
